import * as types from './types';

export const segmentTypesRequest = () => ({ type: types.SEGMENT_TYPES_REQUEST });
export const segmentTypesSuccess = payload => ({ type: types.SEGMENT_TYPES_SUCCESS, payload });
export const segmentTypesFailure = () => ({ type: types.SEGMENT_TYPES_FAILURE });

export const fetchSegmentTypes = () => (
  (dispatch, getState, api) => {
    dispatch(segmentTypesRequest());

    return api.getSegmentTypes()
      .then(response => {
        dispatch(segmentTypesSuccess(response.data.segment_types));
      })
      .catch(error => {
        dispatch(segmentTypesFailure(error));
      });
  }
);

export const segmentsRequest = () => ({ type: types.SEGMENTS_REQUEST });
export const segmentsSuccess = payload => ({ type: types.SEGMENTS_SUCCESS, payload });
export const segmentsFailure = () => ({ type: types.SEGMENTS_FAILURE });

export const fetchSegments = () => (
  (dispatch, getState, api) => {
    dispatch(segmentsRequest());

    return api.getSegments()
      .then(response => {
        dispatch(segmentsSuccess(response.data.segments));
      })
      .catch(error => {
        dispatch(segmentsFailure(error));
      });
  }
);



// WEBPACK FOOTER //
// ./src/redux/segments/actions.js